import React, { useContext, useState, useEffect } from 'react'
import { TopbarContext } from './TopbarContext'
import './Topbar.css'
import { useHistory } from 'react-router-dom'
import { Spinner, Button } from 'react-bootstrap'
import { AuthContext } from '../Auth/AuthContext'
import { LanguageContext } from '../Language/LanguageContext'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { 
    faCog, 
    faBell, 
    faBars, 
    faSignOutAlt, 
    faQuestionCircle, 
    faCommentDots, 
    faHandPaper,
    faFileAlt,
    faKey,
    faLanguage, 
    faUserCircle,
    faDownload,
} from '@fortawesome/free-solid-svg-icons'
import { countNotification, listNotification } from '../Network/Notification'
import { ModalContext } from './ModalContext'
import dayjs from 'dayjs'
import DownloadApp from './DownloadApp'
import Feedback from './Feedback'

const menuRef = React.createRef()
const notiMenuRef = React.createRef()
const menuButtonRef = React.createRef()

function Topbar(props) {
    const langCx = useContext(LanguageContext)
    const authCx = useContext(AuthContext);
    const modal = useContext(ModalContext)
    const history = useHistory();
    const [settingShow, setSettingShow] = useState(false);
    const [isNotificationShow, setNotificationShow] = useState(false)
    const topbarCx = useContext(TopbarContext);
    const [countNoti, setCountNoti] = useState(0);

    const name = localStorage.getItem("name")
    const email = localStorage.getItem("email")
    const profileImg = localStorage.getItem("profile_img")

    const showModalDownloadApp = () =>{
        const langModal = langCx.lang.download_app
        modal.setHeader(langModal.download)
        modal.setDisableBackDrop(false)
        modal.setShowHeader(true)
        modal.setDark(false)
        modal.setComponent(
            <DownloadApp/>
        )
        modal.setShow(true)
    }

    const showModalFeedback = () =>{
        const langFeedback = langCx.lang.feedback
        modal.setHeader(langFeedback.send_feedback)
        modal.setDisableBackDrop(false)
        modal.setShowHeader(true)
        modal.setDark(false)
        modal.setComponent(
            <Feedback onCancel={()=>modal.setShow(false)}/>
        )
        modal.setShow(true)
    }
    
    useEffect(()=>{
        const clickOutside = (e) =>{
            if(!menuRef?.current.contains(e.target)){
                setSettingShow(false)
            }
        }
        const fetchNotificationCount = () =>{
            countNotification(
                (bell, inbox)=>{
                    setCountNoti(bell)
                },
                (error)=>{}
            )
        }
        document.addEventListener('mousedown', clickOutside, false)
        fetchNotificationCount()
        return(()=>{
            document.removeEventListener('mousedown', clickOutside, false)
        })
    },[])

    return (
        <div>
            <div id="topbar">
                <div className="bar-container">
                    <div className="bar-button d-block d-md-none" onClick={()=>props.onClickOpen()}>
                        <FontAwesomeIcon icon={faBars} color="#00275e"/>
                    </div>
                    <div className="header-title">
                        <b>{topbarCx.title}</b>
                    </div>
                </div>
                <div className="bar-right">
                    {/* <BarButton 
                    icon={faBell}
                    countNotification={countNoti}
                    isSelected={isNotificationShow}
                    onClick={()=>{
                        setNotificationShow(!isNotificationShow ? true:false)
                    }}
                    /> */}
                    <BarButton 
                    icon={faCog}
                    isSelected={settingShow}
                    onClick={()=>setSettingShow(!settingShow ? true:false)}/>
                    
                </div>
            </div>
            <NotificationMenu
            top={70}
            right={70}
            isShow={isNotificationShow}
            onHide={()=>setNotificationShow(false)}
            onRedirect={()=>showModalDownloadApp()}
            />
            <MenuList
            onRef={menuRef}
            isShow={settingShow}
            top={70}
            right={12}
            topHeader={
                <div className="user-info">
                    { profileImg !== "" ?
                    <img src={profileImg} className="user-img"/>
                    :
                    <FontAwesomeIcon icon={faUserCircle} className="user-placeholder"/>
                    }
                    <div style={{marginLeft:13}}>
                        <div className="user-name">{name}</div>
                        <div className="user-email">{email}</div>
                    </div>
                </div>
            }
            lists={[
                {
                    title: langCx.lang.menu.change_password,
                    action: ()=>{
                        history.push("/change-password")
                        setSettingShow(false)
                    }, 
                    icon: faKey
                },
                // {
                //     title: langCx.lang.menu.language, 
                //     action: ()=>{
                //         history.push("/language")
                //         setSettingShow(false)
                //     }, 
                //     icon: faLanguage
                // },
                {
                    title: langCx.lang.download_app.download,
                    icon: faDownload,
                    action: ()=>{
                        showModalDownloadApp()
                        setSettingShow(false)
                    }
                },
                {
                    title: langCx.lang.sidebar.term, 
                    action: ()=>{
                        history.push("/view-term")
                        setSettingShow(false)
                    }, 
                    icon: faFileAlt
                },
                {   
                    title: langCx.lang.menu.feedback, 
                    action: ()=>{
                        showModalFeedback()
                        setSettingShow(false)
                    }, 
                    icon: faCommentDots},
                {
                    title: langCx.lang.menu.logout, 
                    action: ()=>{
                        authCx.signout(()=>window.location.replace("/login"))
                    }, 
                    icon: faSignOutAlt
                },
                // {title: langCx.lang.menu.help, 
                // action: ()=>{
                //     console.log("HELP")
                // }, 
                // icon: faQuestionCircle}
            ]}
            />
        </div>
    )
}

function BarButton({ icon, countNotification, onClick, isSelected }){

    var countNoti = "0"
    if(countNotification !== undefined){
        if(countNotification > 99){
            countNoti = "99+"
        }else{
            countNoti = countNotification
        }
    }

    return(
        <div className="bar-button"
        style={{
            backgroundColor: isSelected ? "rgba(200, 200, 200, 0.5)": null
        }}
        ref={menuButtonRef}
        role="button"
        tabIndex="0"
        aria-pressed="false"
        onKeyDown={(e)=>{
            if(e.key === "Enter"){
                onClick()
            }
        }}
        onClick={onClick}
        >
            <FontAwesomeIcon icon={icon} color="#00275e"/>
            { countNotification !== undefined && countNotification > 0 ?
            <div className="notification-badge">
                {countNoti}
            </div>
            : null
            }
        </div>
    )
}

function NotificationMenu({ 
    top, left, right, bottom, onHide, onRedirect, isShow
}){
    const langCx = useContext(LanguageContext)
    const lang = langCx.lang.notification

    const [isLoadingNoti, setLoadingNoti] = useState(false)
    const [notificationList, setNotificationList] = useState([])
    const [page, setPage] = useState(1)
    const size = 10
    const [lastLength, setLastLength] = useState(0)

    const fetchNotification = (page, size, loadnew) =>{
        setLoadingNoti(true)
        listNotification(page, size,
            (data)=>{
                if(loadnew){
                    setNotificationList(data)
                    setLastLength(data.length)
                }else{
                    data.map((item)=>{
                        setNotificationList(oldData => [...oldData, item])
                    })
                    setLastLength(data.length)
                }
                setLoadingNoti(false)
            },
            (error)=>{
                setLoadingNoti(false)
            })
            
    }
    
    const loadMore = () =>{
        var nextPage = page + 1
        fetchNotification(nextPage, size, false)
        setPage(nextPage)
    }

    const onScrollNotification = (event) =>{
        const target = event.target
        if(target.scrollHeight - target.scrollTop === target.clientHeight){
            if(lastLength >= size - 2){
                loadMore()
            }
        }
    }

    const NotificationItem = ({ title, description, date, isRead, onClick }) =>{
        return(
            <div 
            className="notification-item" 
            role="button"
            tabIndex="0"
            aria-pressed="false"
            onKeyDown={(e)=>{
                if(e.key === "Enter"){
                    onClick()
                }
            }}
            onClick={onClick}>
                <div>
                    <div className="title">{title}</div>
                    <div className="desc">{description}</div>
                    <div className="desc">{dayjs(date).format("D MMM YYYY - H:mm")}</div>
                </div>
                <div>
                    { !isRead ?
                    <div className="red-dot"></div>
                    : null
                    }
                </div>
            </div>
        )
    }

    useEffect(()=>{
        const clickOutside = (e) =>{
            if(!notiMenuRef?.current.contains(e.target)){
                onHide()
            }
        }
        document.addEventListener('mousedown', clickOutside, false)
        fetchNotification(page, size, true)
        return(()=>{
            document.removeEventListener('mousedown', clickOutside, false)
        })
    },[])

    return(
        <div 
        ref={notiMenuRef}
        className="menu-list"
        style={{
            visibility: isShow ? 'visible': 'hidden',
            opacity: isShow ? 1 : 0,
            top: isShow ? top : top - 10,
            //top: top,
            left: left,
            right, right,
            bottom: bottom,
            width: 350,
        }}>
            <div className="menu-header">
                <div>{lang.notification}</div>
                { isLoadingNoti ?
                <div>
                    <Spinner animation="border"
                    size="sm"/>
                </div>
                : null
                }
            </div>
            <div className="noti-container" onScroll={onScrollNotification}>
                <div>
                    { notificationList.map((item, key)=>
                    <NotificationItem
                    key={key}
                    title={item.title}
                    description={item.content}
                    date={item.createdDate}
                    isRead={item.read}
                    onClick={()=>onRedirect()}
                    />
                    )}
                </div>
                { notificationList.length === 0 ?
                <div style={{ textAlign: 'center', marginBottom: 10 }}>
                    {lang.no_notification}
                </div>
                : null
                }
                { lastLength >= size - 2 ?
                <div style={{ textAlign: 'center', marginTop: 13, marginBottom: 13 }}>
                    <Button size="sm" onClick={()=>loadMore()}>
                        {lang.show_more}
                    </Button>
                </div>
                : null
                }
                
            </div>
        </div>
    )
}

function MenuList(props){

    return(
        <div 
        ref={props.onRef}
        className="menu-list" 
        style={{
            //display: props.isShow ? 'block': 'none',
            visibility: props.isShow ? 'visible': 'hidden',
            opacity: props.isShow ? 1 : 0,
            top: props.isShow ? props.top : props.top - 10,
            left: props.left,
            right: props.right,
            bottom: props.bottom
        }}>
            { props.topHeader !== undefined ?
            <div>
                {props.topHeader}
                <hr style={{margin: 0, marginBottom: 10}}/>
            </div>
            : null
            }
            { props.lists.map((item, key)=>
                <div 
                className="menu-list-item"
                key={key}
                role="button"
                tabIndex="0"
                aria-pressed="false"
                onKeyDown={(e)=>{
                    if(e.key === "Enter"){
                        item.action()
                    }
                }}
                onClick={item.action}
                >
                    <div style={{ width: 35 }}>
                        <FontAwesomeIcon 
                        icon={item.icon}
                        className="menu-list-icon"
                        />
                    </div>
                    <div>
                        {item.title}
                    </div>
                </div>
            )}
        </div>
    )
}

export default Topbar
